import styled from 'styled-components';
import { FlexRow } from '@make-software/tg-mini-app-ui';

export const StyledEarnContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    background: '#30313B',
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'center',
    height: '64px',
    borderRadius: '8px',
    border: '1px solid #41424E',
    width: '50%',
    gap: '12px'
  })
);

export const StyledBalanceRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    margin: '16px 0'
  })
);

export const IconContainer = styled.div`
  width: 2.75rem;
  height: 2.75rem;
  flex-shrink: 0;
  background-color: #bbbedf3b;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 0.34375rem;
`;
